import React from 'react';
import styled from 'styled-components';

const StyledDataCardBody = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex-grow: 1;
  border: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  border-radius: 5px;
`;

const DataCardBody = React.forwardRef(({ height, children }, ref) => {
  return (
    <StyledDataCardBody
      ref={ref}
      height={height}
      data-name="alert-data-card-body"
    >
      {children}
    </StyledDataCardBody>
  );
});

export default DataCardBody;
